<template>
  <header class="app-header" :class="{ scrolled: isScrolled }">
    <div class="header-container">
      <div class="logo" @click="$router.push('/')">
        <span class="logo-text">Brilliantet海外留学</span>
      </div>
      <nav class="nav-links">
        <router-link to="/" :class="{ active: currentRoute === 'Home' }">首页</router-link>
        <router-link to="/about" :class="{ active: currentRoute === 'About' }">关于我们</router-link>
        <router-link to="/services" :class="{ active: currentRoute === 'Services' }">服务项目</router-link>
        <router-link to="/cases" :class="{ active: currentRoute === 'Cases' || currentRoute === 'CaseDetail' }">成功案例</router-link>
        <router-link to="/news" :class="{ active: currentRoute === 'News' || currentRoute === 'NewsDetail' }">新闻资讯</router-link>
        <router-link to="/contact" :class="{ active: currentRoute === 'Contact' }">联系我们</router-link>
      </nav>
      <el-button type="primary" round @click="$router.push('/contact')">免费咨询</el-button>
      <div class="mobile-menu-btn" @click="showMobileMenu = !showMobileMenu">
        <el-icon :size="24"><Menu /></el-icon>
      </div>
    </div>
    <!-- 移动端菜单 -->
    <transition name="slide">
      <div class="mobile-nav" v-if="showMobileMenu">
        <router-link to="/" @click="showMobileMenu = false">首页</router-link>
        <router-link to="/about" @click="showMobileMenu = false">关于我们</router-link>
        <router-link to="/services" @click="showMobileMenu = false">服务项目</router-link>
        <router-link to="/cases" @click="showMobileMenu = false">成功案例</router-link>
        <router-link to="/news" @click="showMobileMenu = false">新闻资讯</router-link>
        <router-link to="/contact" @click="showMobileMenu = false">联系我们</router-link>
        <el-button type="primary" round style="width: 100%; margin-top: 10px" @click="$router.push('/contact'); showMobileMenu = false">免费咨询</el-button>
      </div>
    </transition>
  </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'
import { Menu } from '@element-plus/icons-vue'

const route = useRoute()
const isScrolled = ref(false)
const showMobileMenu = ref(false)

const currentRoute = computed(() => route.name)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 60
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.98);
  transition: all 0.3s ease;
  box-shadow: none;
}

.app-header.scrolled {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  display: flex;
  align-items: baseline;
  gap: 6px;
  cursor: pointer;
  flex-shrink: 0;
}

.logo-text {
  font-size: 26px;
  font-weight: 700;
  color: var(--primary-color);
  letter-spacing: -0.5px;
}

.logo-sub {
  font-size: 16px;
  color: var(--text-secondary);
  font-weight: 500;
}

.nav-links {
  display: flex;
  gap: 32px;
}

.nav-links a {
  font-size: 15px;
  color: var(--text-color);
  padding: 6px 0;
  position: relative;
  transition: color 0.3s;
  font-weight: 500;
}

.nav-links a:hover,
.nav-links a.active {
  color: var(--primary-color);
}

.nav-links a.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--primary-color);
  border-radius: 1px;
}

.mobile-menu-btn {
  display: none;
  cursor: pointer;
  color: var(--text-color);
}

.mobile-nav {
  display: none;
  flex-direction: column;
  padding: 16px 20px 24px;
  background: #fff;
  border-top: 1px solid var(--border-color);
}

.mobile-nav a {
  padding: 12px 0;
  font-size: 15px;
  color: var(--text-color);
  border-bottom: 1px solid var(--border-color);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 900px) {
  .nav-links,
  .header-container .el-button {
    display: none;
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-nav {
    display: flex;
  }
}
</style>
